import { render, staticRenderFns } from "./EditCampaignNoteDialog.vue?vue&type=template&id=4765ac3f&scoped=true&"
import script from "./EditCampaignNoteDialog.vue?vue&type=script&lang=js&"
export * from "./EditCampaignNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaignNoteDialog.vue?vue&type=style&index=0&id=4765ac3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765ac3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4765ac3f')) {
      api.createRecord('4765ac3f', component.options)
    } else {
      api.reload('4765ac3f', component.options)
    }
    module.hot.accept("./EditCampaignNoteDialog.vue?vue&type=template&id=4765ac3f&scoped=true&", function () {
      api.rerender('4765ac3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/changelog/EditCampaignNoteDialog.vue"
export default component.exports